import {
	Container,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React, { useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { bffCallmeSend } from 'src/bff';
import {
	ConfirmacionEnvio,
	ConsentQuestion,
	InputGroupWrapper,
	Nombre,
	Telefono,
} from 'src/components';
import {
	FormController,
	useFaContent,
	useIsComerciales,
	useOneFormContext,
} from 'src/feature-app';
import { getParamsForm } from 'src/feature-app/get-params-form';
import { LayoutWrapper } from 'src/feature-app/Screen';
import { FormDataGroup, FormInfo, OneFormState, Steps } from 'src/types';
import { ThankYouCallMeOferta } from '.';

export function CallMeOfertaForm() {
	const { initializeForm } = useOneFormContext();
	const store = useStore();
	const dispatch = useDispatch();
	const faContent = useFaContent();
	const isComerciales = useIsComerciales();

	let index = 0;
	const steps: Steps[] = [
		{
			title: (
				<Container wrap={'always'}>
					<Text>
						Para llamarte, necesitamos{' '}
						<Text bold>tus datos de contacto</Text>
					</Text>
					<Text appearance={TokenTextAppearance.copy200}>
						Nos pondremos en contacto contigo de lunes a viernes de
						9:00 h a 19:30 h (excepto festivos nacionales) para
						darte más información.
					</Text>
				</Container>
			),
			fields: (
				<LayoutWrapper>
					<InputGroupWrapper>
						<Nombre />
						<Telefono hidePrefijo={isComerciales} required />
					</InputGroupWrapper>
				</LayoutWrapper>
			),
			screenIndex: index++,
			name: 'NombreTelefono',
			outputs: ['name', 'cellphone'],
			outputsText: ['name', 'cellphone'],
		},
		{
			fields: <ConsentQuestion questionType="lssi" />,
			screenIndex: index++,
			name: 'lssi',
			outputs: ['lssi'],
		},
		{
			fields: <ConsentQuestion questionType="tmk" />,
			screenIndex: index++,
			name: 'tmk',
			outputs: ['tmk'],
		},
		{
			fields: <ConfirmacionEnvio />,
			screenIndex: index++,
			name: 'Confirmacion',
			isLastStep: true,
			hidePreviousStep: true,
		},
	];

	const NuevoFormData: Partial<FormDataGroup> = {
		headers: {
			DESC_BRAND: 'VW',
			DESC_VN_VO: 'VN',
			DESC_GDPR_ADAPTED: 'true',
		},
		fields: {
			formName: 'callme-oferta',
			formType: 'contact',
			pageCategory: 'Call Me Oferta',
		}, // Analítica
	};

	const getFormInfo = (): {
		firstStep: Steps;
		lastStep: Steps;
		stepsHistory: number[];
		numberOfScreens: number;
		newSteps?: Steps[];
	} => {
		return {
			firstStep: steps[0],
			lastStep: steps[steps.length - 1],
			stepsHistory: [0],
			numberOfScreens: steps.length,
			newSteps: null,
		};
	};

	const sendForm = (): Promise<boolean> => {
		const { formData }: OneFormState = store.getState();
		const { fields } = formData;

		return new Promise<any>(async (resolve, reject) => {
			const { tc, today, referalUrl, url, device } = getParamsForm();

			const data = {
				brand: isComerciales ? 'N' : 'V',
				name: fields.name,
				prefix: fields.prefix,
				cellphone: fields.cellphone,
				lssi: fields.lssi,
				tmk: fields.tmk,
				ref: url,
				ofertaId: faContent.oferta.id,
			};

			const { success, response } = await bffCallmeSend(data);

			if (success) {
				dispatch({ type: 'SET_FORM_RESPONSE', payload: response.data });
				resolve(true);
			} else {
				resolve(false);
			}
		});
	};

	useEffect(() => {
		const { firstStep, lastStep, stepsHistory, numberOfScreens, newSteps } =
			getFormInfo();

		const NuevoFormInfo: Partial<FormInfo> = {
			formStarted: true,
			sendFormCallback: sendForm,
			fullScreen: firstStep.fullScreen ? true : false,
			lastStep,
			numberOfScreens,
			formTheme: 'inverted',
			screenIndex: firstStep.screenIndex,
			step: firstStep,
			steps: newSteps ? newSteps : steps,
			notALayer: false,
			formType: 'layer',
			stepsHistory,
			thankYouComponent: <ThankYouCallMeOferta />,
		};

		initializeForm(NuevoFormInfo, NuevoFormData);
	}, []);

	return <FormController steps={steps} screenType="layer-screen" />;
}
